import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const ArrowDown: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.9919 10.038V20.0759L7.84794 16.932L4.70396 13.7881L3.99596 14.4961L3.28796 15.2041L7.64396 19.56L11.9999 23.916L16.3559 19.56L20.7119 15.2041L20.0039 14.4961L19.2959 13.7881L16.1519 16.932L13.0079 20.0759V10.038V0H11.9999H10.9919V10.038Z'
        fill={fill}
      />
    </svg>
  )
}

export default ArrowDown
